<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Changer mot de passe
            </strong>
          </div>
          <b-form>
            <b-form-group
              description="Ancien mot de passe"
              label="Ancien mot de passe"
              label-for="current-password"
              :label-cols="3"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input
                  :type="oldFieldType"
                  id="current-password"
                  name="current-password"
                  :class="{hasError: errors.currentPassword !== ''}"
                  v-model="currentPassword"
                />
                <button type="button" class="btn btn-primary" @click="showOldPasswd"><i :class="old"></i></button>
              </b-input-group>
              <span class="field-error">{{ errors.currentPassword }}</span>
            </b-form-group>
            <b-form-group
              description="Nouveau mot de passe"
              label="Nouveau mot de passe"
              label-for="new-password"
              :label-cols="3"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input
                  :type="newFieldType"
                  id="new-password"
                  name="new-password"
                  :class="{hasError: errors.newPassword !== ''}"
                  v-model="newPassword"
                />
                <button type="button" class="btn btn-primary" @click="showNewPasswd"><i :class="eye"></i></button>
              </b-input-group>
              <span class="field-error">{{ errors.newPassword }}</span>
            </b-form-group>
            <b-form-group
              description="Confirmation"
              label="Confirmation nouveau mot de passe"
              label-for="new-password-confirm"
              :label-cols="3"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input
                  :type="confirmFieldType"
                  id="new-password-confirm"
                  name="new-password-confirm"
                  :class="{hasError: errors.confirmPassword !== ''}"
                  v-model="confirmPassword"
                />
                <button type="button" class="btn btn-primary" @click="showConfirmPasswd"><i :class="confirm"></i></button>
              </b-input-group>
              <span class="field-error">{{ errors.confirmPassword }}</span>
            </b-form-group>
            <div slot="footer">
              <b-button type="button" @click="save" size="md" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  getBaseUrl,
  getProvider,
  getIdToken,
  getAccessToken
} from "../../../utils/auth";

export default {
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      oldFieldType: 'password',
      newFieldType: 'password',
      confirmFieldType: 'password',
      eye: 'fa fa-eye',
      old: 'fa fa-eye',
      confirm: 'fa fa-eye',
      errors: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] =
      getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    showOldPasswd() {
      this.oldFieldType = this.oldFieldType === 'password' ? 'text' : 'password';
      this.old = this.oldFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash';
    },
    showNewPasswd() {
      this.newFieldType = this.newFieldType === 'password' ? 'text' : 'password';
      this.eye = this.newFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash';
    },
    showConfirmPasswd() {
      this.confirmFieldType = this.confirmFieldType === 'password' ? 'text' : 'password';
      this.confirm = this.confirmFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash';
    },
    save() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        let dataPost = {};
        let valid = true;

        dataPost.currentPassword = this.currentPassword;
        dataPost.newPassword = this.newPassword;
        dataPost.confirmPassword = this.confirmPassword;

        this.$axios
          .put("/administration/change-passwd", dataPost)
          .then(response => {
            if (response.data.status == "success") {
              valid = true;
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "Votre mot de passe a bien été modifié",
                showConfirmButton: false,
                timer: 5000
              });
              this.$router.push({ path: "/administration/compte-user" });
            } else if (response.data.status == "error-mdp") {
              valid = false;
              this.$store.commit("IS_LOADING", false);
              this.errors.currentPassword = response.data.message;
              return valid;
            } else if (response.data.status == "error-new") {
              valid = false;
              this.$store.commit("IS_LOADING", false);
              this.errors.newPassword = response.data.message;
              return valid;
            }
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      let regPassword = this.$store.getters.getRegPassword

      if (this.currentPassword === "") {
        this.errors.currentPassword = "Entrer votre ancien mot de passe";
        valid = false;
      }
      if (this.newPassword === "") {
        this.errors.newPassword = "Entrer un nouveau mot de passe";
        valid = false;
      } else if (this.newPassword.trim().match(regPassword) === null) {
        valid = false
        this.errors.newPassword = 'Le mot de passe doit contenir au moins 8 caractères dont 1 minuscule, 1 majuscule et 1 chiffre.'
      }
      if (this.confirmPassword === "") {
        this.errors.confirmPassword = "Entrer un nouveau mot de passe";
        valid = false;
      }
      if (this.newPassword != this.confirmPassword) {
        this.errors.newPassword = "Les mots de passes ne sont pas pareils";
        this.errors.confirmPassword = "Les mots de passes ne sont pas pareils";
        valid = false;
      }
      return valid;
    },
    clearErrors() {
      this.errors.currentPassword = "";
      this.errors.newPassword = "";
      this.errors.confirmPassword = "";
    }
  }
};
</script>

<style>
</style>
